import React from 'react';

import { FlatList, View } from 'react-native';

import { isTabletOrWeb } from 'utils/responsiveness';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

function Section({
    title,
    data,
    renderItem,
    ...flatListProps
}: {
    title: string;
    data: any;
    renderItem: any;
}) {
    return (
        <View>
            <Text
                accessibilityLabel={title}
                accessibilityRole="header"
                style={styles.text}
                category={
                    isTabletOrWeb ? ETextCategory.body1 : ETextCategory.title3
                }
                color={ETextColor.neutral}
                bold
            >
                {title}
            </Text>
            <FlatList
                data={data}
                renderItem={renderItem}
                {...flatListProps}
                contentContainerStyle={styles.contentContainer}
            />
        </View>
    );
}

export default Section;
